







































import Vue from 'vue';
import { capitalize } from 'lodash';

export default Vue.extend({
  name: 'App',
  methods: {
    getConfigsList(): string[] {
      return require.context(
        '@/game-configs/custom/',
        false,
        /^.*\.ts$/,
      ).keys()
       .map((config: string) => {
        // remove leading './' and ending '.ts'
        return capitalize(config.substring(
          config.lastIndexOf('/') + 1,
          config.lastIndexOf('.'),
        ));
       });
    },
  },
});
